import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartBar, faChartLine } from "@fortawesome/free-solid-svg-icons";

function Analytics() {
  return (
    <div className="flex items-center gap-2">
      <FontAwesomeIcon
        icon={faChartBar}
        style={{ color: "#000000", fontSize: "26px", padding: "4px" }}
      />
       
    </div>
  );
}

export default Analytics;